"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function LymphdrainageHero() {
  const scrollToNextSection = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth"
      });
    }
  };
  return <section data-section-id="262592" id="lymphdrainage-hero" className="relative flex min-h-[500px] h-[70vh] w-full flex-col overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/lymphdrainage_treatment_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/lymphdrainage_treatment_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/lymphdrainage_treatment_hero.png-wvc-sizes" alt="Lymphdrainage Behandlung" className="h-full w-full object-cover !bg-[rgba(225,231,239,1)] opacity-89" loading="eager" src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/lymphdrainage-581fa05b.jpg" />
        {}
        <div className="absolute inset-x-0 top-0 h-48 bg-gradient-to-b from-background/40 to-transparent"></div>
        {}
        <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-background/60 to-transparent"></div>
      </div>

      {}
      <div className="relative z-10 mt-auto flex w-full items-end justify-between px-6 pb-12 md:px-12">
        {}
        <div className="relative">
          <span className="pointer-events-none absolute -bottom-4 -left-2 select-none font-serif text-[100px] leading-none tracking-wider text-primary/5 md:-bottom-8 md:-left-4 md:text-[160px]">
            Vitalität
          </span>
          <div className="relative flex flex-col gap-2">
            <h1 className="font-default leading-tight !text-7xl !text-[rgba(44,125,132,1)] !font-extrabold">FLOW STATT GROW!<br />Bring Deine Lymphe <br />in Bewegung!<br /></h1>
            <p className="font-default text-muted-foreground !text-5xl"><br />Leicht, vital und voller Energie – <br />tue deinem Körper etwas Gutes!</p>
          </div>
        </div>

        {}
        <Button variant="outline" size="icon" onClick={scrollToNextSection} className="size-12 shrink-0 rounded-lg border-none bg-primary text-primary-foreground shadow-lg hover:bg-primary/90 md:size-14 animate-bounce" aria-label="Scorri verso il basso">
          <ArrowDown className="size-6" />
        </Button>
      </div>
    </section>;
}